import { ElementRef } from '@angular/core';
import { RR_LINK_TARGET } from '../enum/link-target.enum';
import { RR_TOOLTIP_POSITION } from '../enum/tooltip-position.enum';

export interface RRLinkModel {
  routerLink?: string;
  url?: string;
  target?: RR_LINK_TARGET;
  label?: string;
  class?: string;
  clickEvent?: string;
  iconClass?: string;
  iconId?: string;
  template?: ElementRef;
  tooltip?: string;
  tooltipPosition?: RR_TOOLTIP_POSITION;
}
